var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgFriend = function SvgFriend(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 7.5,
    cy: 4.5,
    r: 3.1,
    fill: "#F2A93B"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#F2A93B",
    d: "M1.7 13.5c0-3.1 2.6-5.1 5.8-5.1s5.8 2 5.8 5.1a.6.6 0 0 1-.6.6H2.3a.6.6 0 0 1-.6-.6"
  })));
};
export default SvgFriend;